module.exports = __webpack_public_path__ + "4849817ddd64bf2bb3e4f9ad5e36eba9.fbx";